import { Organization } from 'models/organization';

const SWEDEN_COUNTRY_CODE = 'SE';

// Swedish PIN validation applies when the organization is in Sweden.
// Organizations without a country set are treated as Swedish.
export const requiresSwedishPinValidation = (organization?: Organization) => {
    const country = organization?.contact?.address?.country;
    return !country || country.toUpperCase() === SWEDEN_COUNTRY_CODE;
};

export const formatPinNumber = (input: string) => {
    const currentYear = new Date().getFullYear();
    let pin = input.replace('+', '').replace('-', '');
    if (pin.length !== 12) {
        const century = parseInt(pin.slice(0, 2), 10) > parseInt(currentYear.toString().slice(2, 4), 10) ? '19' : '20';
        pin = `${century}${pin}`;
    }

    const formatted = `${pin.slice(0, 8)}-${pin.slice(8)}`;
    if (isValidPinNumber(formatted)) {
        return formatted;
    }
    return input;
};

export const isValidPinNumber = (search: string) => {
    const regex = /^(?:\d{2})?\d{6}[-+]?\d{4}$|^\d{6}[-+]?\d{4}$|^\d{12}$/;
    return regex.test(search);
};
